import { Injectable } from '@angular/core';

import * as _ from 'lodash';
import * as moment from 'moment';
import { GfTranslateService } from '../../../../services/core.translate.service';
import { marker } from '../../../../services/ngx-translate-extract-marker';

function getPackageTitle(pkg) {
    var projName = _.get(pkg, 'project.unixName', false);
    var pkgName = _.get(pkg, 'packageName', '(No name)');

    if (projName) {
        return projName + '::' + pkgName;
    }
    return pkgName;
}

@Injectable()
export class FrsReportHelper {

    constructor(
        private gfTranslateService: GfTranslateService,
    ) { }

    getOption = (id, label, defaultSelected = false) => {
        return { id: id, label: this.gfTranslateService.translate(label), defaultSelected: defaultSelected };
    }
    getAnyFilterObj() {
        return this.getOption('', marker('Any'), true);
    }
    getCustomFilterObj() {
        return this.getOption(null, marker('Custom'), false);
    }
    getYesNoElements() {
        return [
            this.getOption('N', marker('No'), true),
            this.getOption('Y', marker('Yes'), false)
        ];
    }
    getRangeDateElements() {
        // NOTE: Any is not the default for this filter.
        var any = this.getAnyFilterObj();
        any.defaultSelected = false;

        return [
            this.getOption('-7 days', marker("This Week"), true),
            this.getOption('-15 days', marker("Last 15 days")),
            this.getOption('-30 days', marker("Last 30 days")),
            this.getOption('-60 days', marker("Last 60 days")),
            this.getOption('-90 days', marker("Last 90 days")),
            this.getOption('-365 days', marker("Last year"))
        ];
    }
    getPackageFieldElements = (packages) => {
        return [this.getAnyFilterObj()]
            .concat(_.map(packages, this.getElementFromPackage));
    }
    getElementFromPackage = (pkg) => {
        return this.getOption(_.get(pkg, 'id', 0), getPackageTitle(pkg));
    }
    getBaseFilters(packageList) {
        var any = this.getAnyFilterObj();
        var yesNo = this.getYesNoElements();
        var no = yesNo[0];

        var ret = [
            { alias: "package", fieldName: this.gfTranslateService.translate("Package"), value: any, fieldType: 1, isExtraField: false, fieldElements: this.getPackageFieldElements(packageList) },
            { alias: "subprojects", fieldName: this.gfTranslateService.translate("Include Subprojects"), value: no, fieldType: 1, isExtraField: false, fieldElements: this.getYesNoElements() },
            { alias: "detail", fieldName: this.gfTranslateService.translate("Show Details"), value: no, fieldType: 1, isExtraField: false, fieldElements: this.getYesNoElements() },
            { alias: "rangeDate", fieldName: this.gfTranslateService.translate("Date Range"), value: '', fieldType: 1, isExtraField: false, fieldElements: this.getRangeDateElements() },
            { alias: "dateFrom", fieldName: this.gfTranslateService.translate("Start Date"), value: '', fieldType: 9, isExtraField: false },
            { alias: "dateTo", fieldName: this.gfTranslateService.translate("End Date"), value: '', fieldType: 9, isExtraField: false }
        ];
        return ret;
    }
    getSelectedElement = (filter, stateParams) => {
        var val = _.get(stateParams, filter.alias, false) || '';
        var elem = _.find(filter.fieldElements, { id: val });
        if (!elem) {
            elem = _.find(filter.fieldElements, { defaultSelected: true });
        }
        return elem;
    }
    setFiltersFromStateParams(filters, stateParams) {
        return _.map(
            filters,
            (f) => {
                switch (f.fieldType) {
                    case 1: // list
                        f.value = this.getSelectedElement(f, stateParams);
                        break;

                    default: // text/other
                        f.value = _.get(stateParams, f.alias, '');
                        break;
                }
                return f;
            }
        );
    }
    createChartData(data) {
        var totals = _.get(data, 'totals', []);

        var byPackage = _.map(
            totals,
            function (row) {
                return {
                    key: row.package,
                    count: row.count
                };
            }
        );

        var byRelease = _.map(
            totals,
            function (row) {
                return {
                    key: row.package + '::' + row.release,
                    count: row.count
                };
            }
        );

        return {
            byPackage: this.getPieChartData(byPackage),
            byRelease: this.getPieChartData(byRelease),
            byFile: this.getPieChartData(totals, 'file'),
            byDate: this.getDateChartData(_.get(data, 'date', []))
        };
    }
    getPieChartData(series, keyField = null, valueField = null) {

        keyField = keyField || 'key';
        valueField = valueField || 'count';

        var map = _.reduce(
            series,
            function (carry, item) {
                var key = _.get(item, keyField);
                var newCount = _.get(item, valueField, 0);
                var oldCount = _.get(carry, key, 0);

                carry[key] = oldCount + newCount;

                return carry;
            }, {}
        );

        return _.map(
            map,
            function (value, key) {
                return {
                    key: key,
                    y: parseInt(value)
                };
            }
        );
    }
    getDaysRangeKey(series) {
        var count = ([...new Set(_.map(series, 'day'))].length);

        if (count < 33) {
            return 'YYYY-MM-DD';
        }

        if (count < 92) {
            return 'YYYY-WW';
        }

        return 'YYYY-MM';
    }
    getDaysRangeFormat(series) {
        var count = ([...new Set(_.map(series, 'day'))].length);

        if (count < 92) {
            return 'MMM DD';
        }

        return 'MMM YYYY';
    }
    getDateChartData(series) {

        var reduceKey = this.getDaysRangeKey(series);
        var format = this.getDaysRangeFormat(series);

        var map = _.reduce(
            series,
            function (carry, item) {
                var key = moment(item.day).format(reduceKey);
                var newCount = _.get(item, 'count', 0);
                var oldCount = _.get(carry, key + '.count', 0);

                carry[key] = {
                    day: item.day,
                    count: oldCount + newCount
                };

                return carry;
            }, {}
        );
        var values = _.map(
            map,
            function (row: any) {
                return {
                    x: moment(row.day).format(format),
                    y: row.count
                };
            }
        );

        return [{
            values: values,
            area: true
        }];
    }
    getDetailTable(detail) {
        if (!detail) return false;

        var sorted = _.sortBy(detail, ['username', 'package', 'release', 'day', 'file']);

        return sorted
            .filter((item) => item.username === 'None')
            .concat(sorted.filter(function (item) { return (item.username != 'None'); }));
    }
}